export default "__VITE_ASSET__BOxGtSjt__"